import { deepMergeLeft } from "@welshman/lib";
import { CodeBlock } from "@tiptap/extension-code-block";
import { Document } from "@tiptap/extension-document";
import { Dropcursor } from "@tiptap/extension-dropcursor";
import { Gapcursor } from "@tiptap/extension-gapcursor";
import { History } from "@tiptap/extension-history";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Placeholder } from "@tiptap/extension-placeholder";
import { NostrExtension, Bolt11Extension, FileUploadExtension, ImageExtension, LinkExtension, NAddrExtension, NEventExtension, NProfileExtension, TagExtension, VideoExtension, NSecRejectExtension, } from "nostr-editor";
import { WordCount } from "./WordCount.js";
import { CodeInline } from "./CodeInline.js";
import { BreakOrSubmit } from "./BreakOrSubmit.js";
import { MentionNodeView, Bolt11NodeView, MediaNodeView, EventNodeView } from "../nodeviews/index.js";
export const WelshmanExtension = NostrExtension.extend({
    // Return an empty object or else options can't be passed
    addOptions() {
        return {};
    },
    addExtensions() {
        const { sign, submit, defaultUploadUrl = "https://nostr.build", defaultUploadType = "nip96", } = this.options;
        if (!sign)
            throw new Error("sign is a required argument to WelshmanExtension");
        if (!submit)
            throw new Error("submit is a required argument to WelshmanExtension");
        const extensionOptions = deepMergeLeft(this.options.extensions || {}, {
            codeInline: {
                extend: {
                    renderText: (props) => "`" + props.node.textContent + "`",
                },
            },
            codeBlock: {
                extend: {
                    renderText: (props) => "```" + props.node.textContent + "```",
                },
            },
            bolt11: {
                config: {
                    inline: true,
                    group: "inline",
                },
                extend: {
                    addNodeView: () => Bolt11NodeView,
                },
            },
            image: {
                config: {
                    inline: true,
                    group: "inline",
                    defaultUploadUrl,
                    defaultUploadType,
                },
                extend: {
                    addNodeView: () => MediaNodeView,
                },
            },
            video: {
                config: {
                    inline: true,
                    group: "inline",
                    defaultUploadUrl,
                    defaultUploadType,
                },
                extend: {
                    addNodeView: () => MediaNodeView,
                },
            },
            nevent: {
                config: {
                    inline: true,
                    group: "inline",
                },
                extend: {
                    addNodeView: () => EventNodeView,
                },
            },
            naddr: {
                config: {
                    inline: true,
                    group: "inline",
                },
                extend: {
                    addNodeView: () => EventNodeView,
                },
            },
            nprofile: {
                extend: {
                    addNodeView: () => MentionNodeView,
                },
            },
            breakOrSubmit: {
                config: {
                    submit,
                },
            },
            fileUpload: {
                config: {
                    sign,
                    immediateUpload: true,
                    allowedMimeTypes: [
                        "image/jpeg",
                        "image/png",
                        "image/gif",
                        "image/webp",
                        "video/mp4",
                        "video/mpeg",
                        "video/webm",
                    ],
                },
            },
        });
        const extensions = [];
        const addExtension = (extension, options) => {
            if (options === false)
                return;
            if (options?.extend) {
                extension = extension.extend(options.extend);
            }
            if (options?.config) {
                extension = extension.configure(options.config);
            }
            extensions.push(extension);
        };
        addExtension(Document, extensionOptions.document);
        addExtension(Text, extensionOptions.text);
        addExtension(Paragraph, extensionOptions.paragraph);
        addExtension(History, extensionOptions.history);
        addExtension(CodeBlock, extensionOptions.codeBlock);
        addExtension(CodeInline, extensionOptions.codeInline);
        addExtension(Dropcursor, extensionOptions.dropcursor);
        addExtension(FileUploadExtension, extensionOptions.fileUpload);
        addExtension(Gapcursor, extensionOptions.gapcursor);
        addExtension(BreakOrSubmit, extensionOptions.breakOrSubmit);
        addExtension(ImageExtension, extensionOptions.image);
        addExtension(LinkExtension, extensionOptions.link);
        addExtension(NAddrExtension, extensionOptions.naddr);
        addExtension(NEventExtension, extensionOptions.nevent);
        addExtension(NProfileExtension, extensionOptions.nprofile);
        addExtension(NSecRejectExtension, extensionOptions.nsecReject);
        addExtension(Placeholder, extensionOptions.placeholder);
        addExtension(TagExtension, extensionOptions.tag);
        addExtension(VideoExtension, extensionOptions.video);
        addExtension(Bolt11Extension, extensionOptions.bolt11);
        addExtension(WordCount, extensionOptions.wordCount);
        return extensions;
    },
});
//# sourceMappingURL=Welshman.js.map